/*
 * Copyright (C) 2005 - 2022 TIBCO Software Inc. All rights reserved. Confidentiality & Proprietary.
 * Licensed pursuant to commercial TIBCO End User License Agreement.
 */

export default {
    SELF: 'Self',
    BLANK: 'Blank',
    TOP: 'Top',
    PARENT: 'Parent',
    REPLACE: 'Replace'
};